import { all } from "redux-saga/effects";

import { saga as obterFotosAnimal } from "./actions/obterFotosAnimal";
import { saga as uploadFoto } from "./actions/uploadFotosAnimal";
import { saga as removerFotoAnimal } from "./actions/removerFotoAnimal";

export default all([obterFotosAnimal, uploadFoto, removerFotoAnimal]);
